/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Color_Role_WarningInputs */

const en_enum_color_role_warning = /** @type {(inputs: Enum_Color_Role_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Warning`)
};

const de_enum_color_role_warning = /** @type {(inputs: Enum_Color_Role_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Warning`)
};

/**
* | output |
* | --- |
* | "Role Warning" |
*
* @param {Enum_Color_Role_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_color_role_warning = /** @type {((inputs?: Enum_Color_Role_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Color_Role_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_color_role_warning(inputs)
	return de_enum_color_role_warning(inputs)
});